import { render, staticRenderFns } from "./Text2Content.vue?vue&type=template&id=2c765b87&"
import script from "./Text2Content.vue?vue&type=script&lang=js&"
export * from "./Text2Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports